import { LogoImages, Images, QuestionGroup, QuestionType, ScenarioStep, Steps, Translatable } from '../state/interfaces'
import { addressLocation, providers, provinces } from './common-steps'
import { currentProviderMobile } from './mobile-steps'

export const moving: ScenarioStep = {
  id: Steps.ARE_YOU_MOVING,
  group: QuestionGroup.DEFAULT,
  question: 'are-you-moving_question',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.HOW_MANY_PEOPLE_SIMULTANEOUSLY,
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
    },
    {
      id: 'no',
      text: 'common_no',
    },
  ],
}

export const peopleSimultaneously: ScenarioStep = {
  id: Steps.HOW_MANY_PEOPLE_SIMULTANEOUSLY,
  group: QuestionGroup.DEFAULT,
  question: 'how-many-people-simultaneously_question',
  tip: 'how-many-people-simultaneously_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.HOW_MANY_DEVICES,
  metadata: { grandImage: Images.HOW_MANY_PEOPLE_SIMULTANEOUSLY },
  answers: [
    {
      id: 'people_1_2',
      text: { key: 'option_first-choice-second-choice', options: { first: '1', second: '2' } },
    },
    {
      id: 'people_3_4',
      text: { key: 'option_start-range-to-end-range', options: { start: '3', end: '4' } },
    },
    {
      id: 'people_4_more',
      text: { key: 'option_option-or-more', options: { option: '4' } },
    },
  ],
}

export const peopleSimultaneouslyE: ScenarioStep = {
  ...peopleSimultaneously,
  next: Steps.HOW_MANY_PEOPLE_WORKING_FROM_HOME,
}

export const addressLocationInternet: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.DEFAULT,
  question: 'address-location-internet_question',
  tip: 'address-location-internet_tip',
  type: QuestionType.GOOGLE_AUTOCOMPLETE,
  answerPlaceholder: 'address-location-internet_answerPlaceholder',
  next: Steps.DONE,
  metadata: { grandImage: Images.FIND_HOME },
}

export const howManyDevices: ScenarioStep = {
  id: Steps.HOW_MANY_DEVICES,
  group: QuestionGroup.DEFAULT,
  question: 'how-many-devices_question',
  tip: 'how-many-devices_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.HOW_MANY_PEOPLE_WORKING_FROM_HOME,
  answers: [
    {
      id: 'devices_1_3',
      text: { key: 'option_start-range-to-end-range', options: { start: '1', end: '3' } },
    },
    {
      id: 'devices_4_7',
      text: { key: 'option_start-range-to-end-range', options: { start: '4', end: '7' } },
    },
    {
      id: 'devices_8_10',
      text: { key: 'option_start-range-to-end-range', options: { start: '8', end: '10' } },
    },
    {
      id: 'devices_11_more',
      text: { key: 'option_option-or-more', options: { option: '11' } },
    },
    {
      id: 'devices_i_dont_know',
      text: 'common_i-dont-know',
    },
  ],
}

export const peopleWorkingFromHome: ScenarioStep = {
  id: Steps.HOW_MANY_PEOPLE_WORKING_FROM_HOME,
  group: QuestionGroup.DEFAULT,
  question: 'how-many-people-work-from-home_question',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.STREAMING_VIDEO_QUALITY,
  metadata: { grandImage: Images.HOW_MANY_PEOPLE_WORKING_FROM_HOME },
  answers: [
    {
      id: 'people_0',
      text: 'common_no-one',
    },
    {
      id: 'people_1',
      text: 'option_1-person',
    },
    {
      id: 'people_2',
      text: { key: 'option_person-amount', options: { amount: '2' } },
    },
    {
      id: 'people_3_more',
      text: { key: 'option_person-amount-or-more', options: { amount: '3' } },
    },
  ],
}

export const streamingVideoQuality: ScenarioStep = {
  id: Steps.STREAMING_VIDEO_QUALITY,
  group: QuestionGroup.DEFAULT,
  question: 'streaming-video-quality_question',
  tip: 'streaming-video-quality_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.ONLINE_GAMING,
  metadata: { grandImage: Images.STREAMING_VIDEO_QUALITY },
  answers: [
    {
      id: 'no_streaming_video',
      text: 'option_i-dont-stream',
    },
    {
      id: 'hd',
      text: 'common_hd',
    },
    {
      id: 'four_k',
      text: 'common_4k',
    },
    {
      id: 'streaming_i_dont_know',
      text: 'common_i-dont-know',
    },
  ],
}

export const streamingVideoQualityE: ScenarioStep = {
  ...streamingVideoQuality,
  answers: [
    {
      id: 'no_streaming_video',
      text: 'option_i-dont-stream',
      next: Steps.ONLINE_GAMING,
    },
    {
      id: 'hd',
      text: 'common_hd',
      next: Steps.VALUE_THE_MOST_CHOICES_1,
    },
    {
      id: 'four_k',
      text: 'common_4k',
      next: Steps.VALUE_THE_MOST_CHOICES_1,
    },
    {
      id: 'streaming_i_dont_know',
      text: 'common_i-dont-know',
      next: Steps.ONLINE_GAMING,
    },
  ],
}

export const streamingVideoQualityG: ScenarioStep = {
  ...streamingVideoQuality,
  answers: [
    {
      id: 'no_streaming_video',
      text: 'option_i-dont-stream',
      next: Steps.ONLINE_GAMING,
    },
    {
      id: 'hd',
      text: 'common_hd',
      next: Steps.INTERNET_USAGE,
    },
    {
      id: 'four_k',
      text: 'common_4k',
      next: Steps.INTERNET_USAGE,
    },
    {
      id: 'streaming_i_dont_know',
      text: 'common_i-dont-know',
      next: Steps.ONLINE_GAMING,
    },
  ],
}

export const onlineGaming: ScenarioStep = {
  id: Steps.ONLINE_GAMING,
  group: QuestionGroup.DEFAULT,
  question: 'online-gaming_question',
  tip: 'online-gaming_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.LARGE_FILES_DOWNLOAD_FREQUENCY,
  metadata: { grandImage: Images.ONLINE_GAMING },
  answers: [
    {
      id: 'no_online_gaming',
      text: 'option_no-online-gaming',
    },
    {
      id: 'casual_recreational',
      text: 'option_casual-and-recreational',
    },
    {
      id: 'seriously_competitive',
      text: 'option_seriously-competitive',
    },
    {
      id: 'professional',
      text: 'option_professional-level',
    },
    {
      id: 'online_gaming_i_dont_know',
      text: 'common_i-dont-know',
    },
  ],
}

export const onlineGamingD: ScenarioStep = {
  ...onlineGaming,
  next: Steps.VALUE_THE_MOST_CHOICES_1,
}

export const onlineGamingG: ScenarioStep = {
  ...onlineGaming,
  next: Steps.INTERNET_USAGE,
}

export const largeFiles: ScenarioStep = {
  id: Steps.LARGE_FILES_DOWNLOAD_FREQUENCY,
  group: QuestionGroup.DEFAULT,
  question: 'large-files-download-frequency_question',
  tip: 'large-files-download-frequency_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.INTERNET_USAGE,
  answers: [
    {
      id: 'never',
      text: 'common_never',
    },
    {
      id: 'rarely',
      text: 'common_rarely',
    },
    {
      id: 'weekly',
      text: 'common_weekly',
    },
    {
      id: 'daily',
      text: 'common_daily',
    },
    {
      id: 'large_files_i_dont_know',
      text: 'common_i-dont-know',
    },
  ],
}

export const internetSpeedOrHelp: ScenarioStep = {
  id: Steps.INTERNET_SPEED_OR_HELP,
  group: QuestionGroup.DEFAULT,
  question: 'internetSpeed-or-help_question',
  type: QuestionType.CHOICE_AS_IMAGES,
  answers: [
    {
      id: 'speed-search',
      text: 'choose-a-speed',
      next: Steps.INTERNET_SPEED,
      metadata: { image: Images.SPEED_SEARCH },
    },
    {
      id: 'help',
      text: 'need-help',
      next: Steps.HOW_MANY_PEOPLE_SIMULTANEOUSLY,
      metadata: { image: Images.NEED_HELP },
    },
  ],
}

export const internetSpeedOrHelpG: ScenarioStep = {
  id: Steps.INTERNET_SPEED_OR_HELP,
  group: QuestionGroup.DEFAULT,
  question: 'internetSpeed-or-help_question',
  type: QuestionType.CHOICE_AS_IMAGES,
  answers: [
    {
      id: 'speed-search',
      text: 'choose-a-speed',
      next: Steps.INTERNET_USAGE,
      metadata: { image: Images.SPEED_SEARCH },
    },
    {
      id: 'help',
      text: 'need-help',
      next: Steps.HOW_MANY_PEOPLE_SIMULTANEOUSLY,
      metadata: { image: Images.NEED_HELP },
    },
  ],
}

export const internetSpeed: ScenarioStep = {
  id: Steps.INTERNET_SPEED,
  group: QuestionGroup.DEFAULT,
  question: 'internet-speed_question',
  type: QuestionType.CHOICE_AS_PILLS,
  answerPlaceholder: 'internet-speed_answerPlaceholder',
  answers: [
    { id: '0', text: { key: 'common_min', options: { count: 0 } }, next: Steps.INTERNET_USAGE },
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.INTERNET_USAGE },
    { id: '15', text: { key: 'common_mbps-amount', options: { count: 15 } }, next: Steps.INTERNET_USAGE },
    { id: '25', text: { key: 'common_mbps-amount', options: { count: 25 } }, next: Steps.INTERNET_USAGE },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.INTERNET_USAGE },
    { id: '40', text: { key: 'common_mbps-amount', options: { count: 40 } }, next: Steps.INTERNET_USAGE },
    { id: '50', text: { key: 'common_mbps-amount', options: { count: 50 } }, next: Steps.INTERNET_USAGE },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.INTERNET_USAGE },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.INTERNET_USAGE },
    { id: '120', text: { key: 'common_mbps-amount', options: { count: 120 } }, next: Steps.INTERNET_USAGE },
    { id: '200', text: { key: 'common_mbps-amount', options: { count: 200 } }, next: Steps.INTERNET_USAGE },
    { id: '250', text: { key: 'common_mbps-amount', options: { count: 250 } }, next: Steps.INTERNET_USAGE },
    { id: '300', text: { key: 'common_mbps-amount', options: { count: 300 } }, next: Steps.INTERNET_USAGE },
    { id: '400', text: { key: 'common_mbps-amount', options: { count: 400 } }, next: Steps.INTERNET_USAGE },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.INTERNET_USAGE },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.INTERNET_USAGE },
  ],
}

export const internetSpeedD: ScenarioStep = {
  ...internetSpeed,
  answers: [
    { id: '0', text: { key: 'common_min', options: { count: 0 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '15', text: { key: 'common_mbps-amount', options: { count: 15 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '25', text: { key: 'common_mbps-amount', options: { count: 25 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '40', text: { key: 'common_mbps-amount', options: { count: 40 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '50', text: { key: 'common_mbps-amount', options: { count: 50 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '120', text: { key: 'common_mbps-amount', options: { count: 120 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '200', text: { key: 'common_mbps-amount', options: { count: 200 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '250', text: { key: 'common_mbps-amount', options: { count: 250 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '300', text: { key: 'common_mbps-amount', options: { count: 300 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '400', text: { key: 'common_mbps-amount', options: { count: 400 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.VALUE_THE_MOST_CHOICES_1 },
  ],
}

export const internetSpeedG: ScenarioStep = {
  ...internetSpeed,
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  tip: 'internet-speed-with-slide_tip',
  metadata: { grandImage: Images.SPEED_SEARCH },
  answers: [
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.INTERNET_USAGE },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.INTERNET_USAGE },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.INTERNET_USAGE },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.INTERNET_USAGE },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.INTERNET_USAGE },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.INTERNET_USAGE },
    { id: 'custom-speed', text: 'common_custom-speed', next: Steps.SLIDER_DATA_AMOUNT },
  ],
}

export const postalCode: ScenarioStep = {
  id: Steps.INTERNET_USAGE,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.POSTAL_CODE_INTERNET_USAGE,
  answerPlaceholder: 'postal-code_answerPlaceholder',
  answers: [],
  next: Steps.DONE,
  metadata: { grandImage: Images.INTERNET_SPEED },
}

export const sliderData: ScenarioStep = {
  id: Steps.SLIDER_DATA_AMOUNT,
  group: QuestionGroup.DEFAULT,
  question: 'slider-data_question',
  type: QuestionType.SLIDER_DATA,
  next: Steps.INTERNET_USAGE,
  answers: [],
  metadata: {
    defaultValue: 20,
    min: 0,
    max: 200,
    colorScheme: 'teal',
    sliderMark: [
      {
        value: 0,
        text: '0',
      },
      {
        value: 50,
        text: '50',
      },
      {
        value: 100,
        text: '100',
      },
      {
        value: 200,
        text: '900',
      },
    ],
    dataUnitType: 'Mbps',
    step: 1,
  },
}

export const sliderDataInternetSpeed: ScenarioStep = {
  ...sliderData,
  question: 'slider-data-internet-speed_question',
  next: Steps.INTERNET_USAGE,
}

export const postalCodeF: ScenarioStep = {
  id: Steps.INTERNET_USAGE,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.POSTAL_CODE_INTERNET_USAGE,
  answerPlaceholder: 'postal-code_answerPlaceholder',
  answers: [],
  next: Steps.ADDRESS_LOCATION,
  metadata: { grandImage: Images.INTERNET_SPEED },
}

export const movingStep: ScenarioStep = {
  ...moving,
  next: Steps.INTERNET_SPEED_OR_HELP,
}

export const movingStepInternetC: ScenarioStep = {
  ...moving,
  next: Steps.VALUE_CUSTOMER_OPINIONS,
}

export const currentProviderInternet: ScenarioStep = {
  ...providers,
  question: { key: 'current-provider_question', options: { providerType: 'internet' } },
  answers: [
    {
      id: 'bell',
      text: '' as Translatable,
      metadata: { image: LogoImages.BELL, blueImage: LogoImages.BELL_BLUE },
    },
    {
      id: 'rogers',
      text: '' as Translatable,
      metadata: { image: LogoImages.ROGERS, blueImage: LogoImages.ROGERS_BLUE },
    },
    {
      id: 'telus',
      text: '' as Translatable,
      metadata: { image: LogoImages.TELUS, blueImage: LogoImages.TELUS_BLUE },
    },
    {
      id: 'virgin',
      text: '' as Translatable,
      metadata: { image: LogoImages.VIRGIN, blueImage: LogoImages.VIRGIN_BLUE },
    },
    {
      id: 'fido',
      text: '' as Translatable,
      metadata: { image: LogoImages.FIDO, blueImage: LogoImages.FIDO_BLUE },
    },
    {
      id: 'fizz',
      text: '' as Translatable,
      metadata: { image: LogoImages.FIZZ, blueImage: LogoImages.FIZZ_BLUE },
    },
    {
      id: 'videotron',
      text: '' as Translatable,
      metadata: { image: LogoImages.VIDEOTRON, blueImage: LogoImages.VIDEOTRON_BLUE },
    },
    {
      id: 'shaw',
      text: '' as Translatable,
      metadata: { image: LogoImages.SHAW, blueImage: LogoImages.SHAW_BLUE },
    },
    {
      id: 'cogeco',
      text: '' as Translatable,
      metadata: { image: LogoImages.COGECO, blueImage: LogoImages.COGECO_BLUE },
    },
    {
      id: 'ebox',
      text: '' as Translatable,
      metadata: { image: LogoImages.EBOX, blueImage: LogoImages.EBOX_BLUE },
    },
    { id: 'no-one-provider', text: 'option_none' },
    { id: 'other-provider', text: 'option_other' },
  ],
  next: Steps.ARE_YOU_MOVING,
}

export const currentProviderInternetD: ScenarioStep = {
  ...currentProviderInternet,
  next: Steps.CURRENT_PROVIDER_MOBILE,
}

export const currentProviderMobileD: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE,
  next: Steps.INTERNET_SPEED_OR_HELP,
}

export const provincesStep: ScenarioStep = {
  ...provinces,
  next: Steps.CURRENT_PROVIDER,
}

export const valueCustomerOpinions: ScenarioStep = {
  id: Steps.VALUE_CUSTOMER_OPINIONS,
  group: QuestionGroup.REVIEWS,
  question: 'value-customer-opinions_question',
  type: QuestionType.STARS,
  next: Steps.VALUE_COST_EFFICIENCY,
  answers: [],
}

export const valueCostEfficiency: ScenarioStep = {
  id: Steps.VALUE_COST_EFFICIENCY,
  group: QuestionGroup.REVIEWS,
  question: 'value-cost-efficiency_question',
  type: QuestionType.STARS,
  next: Steps.VALUE_PRICE,
  answers: [],
}

export const valuePrice: ScenarioStep = {
  id: Steps.VALUE_PRICE,
  group: QuestionGroup.REVIEWS,
  question: 'value-price_question',
  type: QuestionType.STARS,
  next: Steps.INTERNET_SPEED_OR_HELP,
  answers: [],
}

export const valueTheMostChoices1: ScenarioStep = {
  id: Steps.VALUE_THE_MOST_CHOICES_1,
  group: QuestionGroup.REVIEWS,
  question: 'value-the-most-choices-1_question',
  tip: 'value-the-most-choices-1_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.INTERNET_USAGE,
  answers: [
    {
      id: 'customer-satisfaction',
      text: 'common_customer-satisfaction',
    },
    {
      id: 'value-for-money',
      text: 'common_value-for-money',
    },
    {
      id: 'price',
      text: 'common_price',
    },
  ],
}

export const valueTheMostChoices1E: ScenarioStep = {
  ...valueTheMostChoices1,
  next: Steps.HOME_PHONE_NEEDED,
}

// export const valueTheMostChoices2: ScenarioStep = {
//   id: Steps.VALUE_THE_MOST_CHOICES_2,
//   group: QuestionGroup.REVIEWS,
//   question: 'value-the-most-choices-2_question',
//   tip: 'value-the-most-choices-2_tip',
//   type: QuestionType.CHOICE_AS_PILLS_LARGE,
//   next: Steps.INTERNET_USAGE,
//   answers: [
//     {
//       id: 'customer-satisfaction',
//       text: 'common_customer-satisfaction',
//     },
//     {
//       id: 'value-for-money',
//       text: 'common_value-for-money',
//     },
//     {
//       id: 'price',
//       text: 'common_price',
//     },
//   ],
// }

// export const valueTheMostChoices2E: ScenarioStep = {
//   ...valueTheMostChoices2,
//   next: Steps.HOME_PHONE_NEEDED,
// }

export const homePhoneNeeded: ScenarioStep = {
  id: Steps.HOME_PHONE_NEEDED,
  group: QuestionGroup.DEFAULT,
  question: 'home_phone_needed_question',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.INTERNET_USAGE,
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
    },
    {
      id: 'no',
      text: 'common_no',
    },
  ],
}

export const businessOrNotInternet: ScenarioStep = {
  id: Steps.BUSINESS_OR_NOT_INTERNET,
  group: QuestionGroup.DEFAULT,
  question: 'business-or-not-internet_question',
  tip: 'business-or-not-internet_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.PROVINCE,
  answers: [
    { id: 'for-me', text: 'common_for-myself', next: Steps.PROVINCE },
    { id: 'for-my-company', text: 'common_for-my-company', next: Steps.DONE },
  ],
}
